import React from 'react'
import Home from './HomeComponent';
import Resume from './ResumeComponent';
import Project from './ProjectComponent';
import Contact from './ContactComponent';
import About from './AboutComponent';
import MenuBar from './MenuComponent';
import { Route, Switch } from 'react-router-dom';
import NavBar from './NavBarComponent';
import { makeStyles } from '@material-ui/core/styles';
import { AnimatePresence } from 'framer-motion';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop:theme.spacing(10)
  },
}));

const Main = () => {
    const classes = useStyles();

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [title, setTitle] = React.useState('Pasan Dewasurendra');

    return (
      <div style={{display:'flex'}}>
        <NavBar title={title} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}/>
        <MenuBar setTitle={setTitle} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}/>

        <main className={classes.content}>
          <AnimatePresence >
            <Switch>
              <Route exact path="/" component={() => <Home />} />
              <Route exact path="/my-portfolio"  component={() => <Home />} />
              <Route path="/about"   component={() => <About />} />
              <Route path="/resume"  component={() => <Resume />} />
              <Route path="/project" component={() => <Project />} />
              <Route path="/contact" component={() => <Contact />} />
            </Switch>
          </AnimatePresence>
        </main>
        
      </div>
    );
  }

  export default Main;